import { IDeleteProjetosChecklistUseCase } from "../../../presentation/useCases/delete/delete_projetos_checklist_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DeleteProjetosChecklistUseCase
 */

export class DeleteProjetosChecklistUseCase implements IDeleteProjetosChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteProjetosChecklist(IdChecklist: number): Promise<void> {
    await this.repository.deleteProjetosChecklist(IdChecklist);
  }
}
